






























import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class Test extends Vue {
  lessonContent = "";

  async mounted(){
    const resp = await fetch('/data/data.json');
    const data = await resp.json();

    this.lessonContent = data.lessons[0].html;
  }
}
